<div>

    <div class="flex mb-4">
        <input id="omnisearch_walletlist" pInputText placeholder="Cerca" [ngModel]="filter()" (ngModelChange)="updateFilter($event)" class="w-full"/>
    </div>


    @for (item of filteredList(); track $index) {
    <div (click)="onSelect.emit(item)" class="cursor-pointer mb-2 spike-list-item flex justify-between items-center">
        <div>{{item.shortDescription}}</div>
    </div>
    }
    
</div>